import { IconDrop } from '@/assets/svgs';
import { SkeletonBox } from '@/shared/ui';

type SearchStationResultItemSkeletonProps = {
	titleWidthClassName?: string;
	addressWidthClassName?: string;
	distanceWidthClassName?: string;
};

const SearchStationResultItemSkeleton = ({
	titleWidthClassName = 'w-40',
	addressWidthClassName = 'w-52',
	distanceWidthClassName = 'w-8',
}: SearchStationResultItemSkeletonProps) => {
	return (
		<li className="flex list-none items-center gap-2 px-5 py-3">
			<IconDrop className="size-4 shrink-0 text-mantang-gray-500" />
			<div className="flex flex-1 flex-col gap-1">
				<SkeletonBox className={`h-5 ${titleWidthClassName}`} />
				<SkeletonBox className={`h-4 ${addressWidthClassName}`} />
			</div>
			<SkeletonBox className={`h-4 shrink-0 ${distanceWidthClassName}`} />
		</li>
	);
};

export default SearchStationResultItemSkeleton;
